export default __webpack_public_path__ + "static/media/iconHyphen.64650a9f.svg";